export default "__VITE_ASSET__tF29TTvi__"